import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { slugify } from "@covertree/utils";

import { Tooltip } from "../Tooltip";
import { CoverageValueFormats } from "@covertree/new-business-mappings";

interface DetailsCardRowProps {
  name: string;
  tooltip?: string;
  valueFormats?: CoverageValueFormats;
  items?: Record<string, string>[];
}

export function DetailsCardRow({
  name,
  tooltip,
  valueFormats,
  items,
}: DetailsCardRowProps) {
  return (
    <Grid
      container
      justifyContent="space-between"
      spacing={2}
      data-testid={slugify(name)}>
      <Grid item xs={6}>
        <Box display="flex" alignItems="center">
          {tooltip && <Tooltip dataTestId={slugify(name)} tooltip={tooltip} />}
          <Typography
            variant="h5"
            sx={{
              marginLeft: {
                xs: 2,
              },
            }}>
            {name}
          </Typography>
        </Box>
      </Grid>
      <Grid item container xs={6} alignItems="center" justifyContent="flex-end">
        <Typography
          variant="h5"
          color="textSecondary"
          align="right"
          data-testid={slugify(`${name}-value`)}>
          {valueFormats?.message || valueFormats?.value}
        </Typography>
      </Grid>
      {items && (
        <Grid
          container
          sx={{
            marginBottom: 2,
            marginTop: -0.5,
          }}>
          {items.map((item) => (
            <Grid
              key={item.name}
              item
              container
              justifyContent="space-between"
              data-testid={slugify(`${name}-item`)}>
              <Grid item key={item.name}>
                <Typography
                  variant="h5"
                  sx={{
                    color: "secondary.main",
                    fontSize: "1rem",
                    marginLeft: 5.75,
                  }}
                  data-testid={slugify(`${name}-item-name`)}>
                  {item.name}
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="subtitle1"
                  color="textSecondary"
                  data-testid={slugify(`${name}-item-value`)}>
                  {item.value}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
}
